<div
  class="notification-container blur-background "
  *ngIf="notifications.length"
>
  <div
    *ngFor="let notification of notifications"
    class="notification"
    [ngClass]="notification.type"
    [attr.id]="'notification-' + notification.id"
  >
    <div class="notification-header">
      <span class="d-flex center">
        <span
          class="material-symbols-outlined logo"
          *ngIf="notification.type == 'error'"
        >
          error
        </span>
        <span
          class="material-symbols-outlined logo"
          *ngIf="notification.type == 'info'"
        >
          info
        </span>
        <span
          class="material-symbols-outlined logo"
          *ngIf="notification.type == 'success'"
        >
          check_circle
        </span>
        <span
          class="material-symbols-outlined logo"
          *ngIf="notification.type == 'warning'"
        >
          warning
        </span>

        <span class="header-title">{{ notification.header }}</span>
      </span>
      <span
        class="material-symbols-outlined close"
        (click)="closeNotification(notification.id)"
      >
        close
      </span>
    </div>
    <div class="notification-content">
      <ng-container *ngIf="isArray(notification.message); else singleMessage">
        <span *ngFor="let msg of notification.message" class="list">{{ msg }}</span>
      </ng-container>
      <ng-template #singleMessage>
        <span>{{ notification.message }}</span>
      </ng-template>
    </div>
  </div>

  <div class="footer" *ngIf="notifications.length > 1">
    <span class="clear-btn" (click)="clearNotifications()">Clear</span>
  </div>
</div>
